import { stringToBinary } from '../../hashing/arrayBuffers.js';

const browserDigest256 = async (crypto, str) => {
  const strBuffer = stringToBinary(str);
  const hashBuffer = await crypto.subtle.digest('SHA-256', strBuffer);
  return hashBuffer;
};
/**
 * Inspired by
 * https://github.com/firebase/firebase-js-sdk/blob/firebase%409.18.0/packages/
 * firestore/src/platform/browser/random_bytes.ts
 */

const browserRandomBytes = (crypto, size) => {
  const bytes = new Uint8Array(size);

  if (typeof (crypto === null || crypto === void 0 ? void 0 : crypto.getRandomValues) === 'function') {
    crypto.getRandomValues(bytes);
  } else {
    // Falls back to Math.random
    for (let i = 0; i < size; i++) {
      bytes[i] = Math.floor(Math.random() * 256);
    }
  }

  return bytes;
};

export { browserDigest256, browserRandomBytes };
